// BriefingBlock — Polish #11. CliffsNotes editorial briefing that sits
// between the frozen work-head and the ThreadView.
//
// Rendering rules:
//   - While loading for the first time, render a subtle skeleton so the
//     block's presence is committed visually (prevents layout jumps when
//     the brief lands a second later).
//   - When the fetch completes with a brief, render it. Null brief → null
//     (the block just disappears and the thread butts up against the head).
//   - Serif type, stone background, monstera left-accent. MD brand DNA.

import { useConversationBrief } from '@/lib/hooks/useConversationBrief';

interface BriefingBlockProps {
  conversationId: string | undefined;
}

export function BriefingBlock({ conversationId }: BriefingBlockProps) {
  const { data, isPending } = useConversationBrief(conversationId);

  if (!conversationId) return null;

  if (isPending) {
    return (
      <aside className="cliffs-brief cliffs-brief--pending" aria-busy>
        <div className="cliffs-brief-eyebrow">Briefing</div>
        <div className="cliffs-brief-skeleton" aria-hidden>
          <span />
          <span />
          <span />
        </div>
      </aside>
    );
  }

  const brief = data?.brief?.trim() ?? '';
  if (brief.length === 0) return null;

  return (
    <aside className="cliffs-brief" role="note">
      <div className="cliffs-brief-eyebrow">Briefing</div>
      <p className="cliffs-brief-body">{brief}</p>
    </aside>
  );
}
